import {
  EnumerateMediaDeviceService,
  GetUserMediaService
} from "../interactors";

export class MediaDeviceService
  implements EnumerateMediaDeviceService, GetUserMediaService
{
  public async getUserMedia(
    constraints?: MediaStreamConstraints
  ): Promise<MediaStream> {
    try {
      const device = await navigator.mediaDevices.getUserMedia(constraints);
      return device;
    } catch (error) {
      console.log("Error getting user media", error);
      console.error(error);
      throw error;
    }
  }

  public async enumerate(): Promise<MediaDeviceInfo[]> {
    let permissionStream: MediaStream | null = null;
    try {
      permissionStream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: true
      });
    } catch (error) {
      console.log(
        "Error getting initial user media (permission may be denied)",
        error
      );
    }
    const devices = await this.enumerateWithoutPermission();
    if (permissionStream) {
      permissionStream.getTracks().forEach((track) => track.stop());
    }
    return devices;
  }

  public async enumerateWithoutPermission(): Promise<MediaDeviceInfo[]> {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      return devices;
    } catch (error) {
      console.log("Error enumerating devices", error);
      console.error(error);
      return [];
    }
  }
}
